import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@edx/frontend-platform/i18n';
import { FormGroup } from '../../../common-components';
import messages from '../../messages';

const GenderField = (props) => {
  const { formatMessage } = useIntl();
  const {
    value,
    handleChange,
    handleErrorChange,
    errorMessage,
    required = false,
    name = 'gender',
  } = props;

  const OPTIONS = [
    { value: '', label: formatMessage(messages['registration.gender.label']) },
    { value: 'm', label: formatMessage(messages['gender.m']) },
    { value: 'f', label: formatMessage(messages['gender.f']) },
    { value: 'o', label: formatMessage(messages['gender.o']) },
  ];

  const handleOnChange = (e) => {
    handleChange({ target: { name, value: e.target.value } });
    if (errorMessage) handleErrorChange(name, '');
  };

  const handleOnBlur = (e) => {
    if (required && !e.target.value) {
      handleErrorChange(
        name,
        'This field is required.' // Kept generic as the field is optional by default
      );
    }
  };

  const handleOnFocus = () => {
    handleErrorChange(name, '');
  };

  const renderOptions = () => (
    <>
      {OPTIONS.map((opt, index) => (
        <option
          key={opt.value || index}
          value={opt.value}
          disabled={opt.value === ''}
          hidden={opt.value === '' && value !== ''}
        >
          {opt.label}
        </option>
      ))}
    </>
  );

  return (
    <FormGroup
      as="select"
      name={name}
      value={value}
      handleChange={handleOnChange}
      handleBlur={handleOnBlur}
      handleFocus={handleOnFocus}
      errorMessage={errorMessage}
      floatingLabel={formatMessage(messages['registration.gender.label'])}
      options={renderOptions}
    />
  );
};

GenderField.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleErrorChange: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  required: PropTypes.bool,
  name: PropTypes.string,
};

GenderField.defaultProps = {
  value: '',
  errorMessage: '',
};

export default GenderField;
